module.exports = __webpack_public_path__ + "img/doctor-icon.0504869d.png";